import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  Alert,
  Container,
  TextInput,
  Text,
  Paper,
  Group,
  Button,
  Anchor,
  Stack,
  Loader,
  Center,
} from "@mantine/core";
import { useStore } from "../store";
import { requestPasswordReset } from "../api";
import { Link } from "wouter";
import { IconInfoCircle } from "@tabler/icons-react";

export default function ForgotPassword() {
  const [isFetching, setIsFetching] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const authToken = useStore((state) => state.authToken);

  const form = useForm({
    initialValues: {
      emailAddress: "",
    },
    validate: {
      emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  if (authToken) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" fw={500}>
            You are logged in
          </Text>
        </Paper>
      </Container>
    );
  }

  if (success) {
    return (
      <Container size="sm" mt="xl">
        <Paper radius="md" p="xl" withBorder>
          <Text size="lg" mb="lg" fw={500}>
            Password reset requested
          </Text>
          <Text>
            Please check your email and follow the reset link to set a new
            password.
          </Text>
        </Paper>
      </Container>
    );
  }

  const errorIcon = <IconInfoCircle />;

  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Login Failed"
          mb="lg"
          icon={errorIcon}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder>
        <Text size="lg" mb="lg" fw={500}>
          Recover Password
        </Text>
        {/* 
        <Divider label="Reset Password" labelPosition="center" my="lg" /> */}

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setErrorMessage(null);

            requestPasswordReset({ ...values })
              .then(() => {
                setIsFetching(false);
                setSuccess(true);
              })
              .catch((err) => {
                setIsFetching(false);
                setErrorMessage("" + err);
              });
          })}
        >
          <Stack>
            <TextInput
              required
              label="Email"
              disabled={isFetching}
              placeholder="john@example.com"
              value={form.values.emailAddress}
              onChange={(event) =>
                form.setFieldValue("emailAddress", event.currentTarget.value)
              }
              error={form.errors.emailAddress && "Invalid email"}
              radius="md"
            />

            <Group justify="space-between" mt="xl">
              <Anchor component={Link} href="/auth/login" c="dimmed" size="xs">
                Login instead
              </Anchor>
              <Button type="submit" radius="xl" disabled={isFetching}>
                Request reset email
              </Button>
            </Group>

            <Center>{isFetching && <Loader />}</Center>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
